import { dispatch, getState } from '../../..';
import PumpingStationMotorMountingHelper, { IPumpingStationMotorMounting } from '../../../../@types/model/masterData/pumpingStation/motorMounting';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorMountingActions from './actions';

export default class MasterDataPumpingStationMotorMountingFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorMountingFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorMountingActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorMountingActions.set([]));

        try {
            MasterDataPumpingStationMotorMountingFunctions.listener = PumpingStationMotorMountingHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorMounting>) => {
                    const state = getState().masterData.pumpingStation.motorMounting;

                    const list = state.motorMountings.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorMountingActions.set(list));
                    dispatch(MasterDataPumpingStationMotorMountingActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorMountingActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorMountingActions.setLoading(false));
                    MasterDataPumpingStationMotorMountingFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorMountingActions.setLoading(false));
        }
    };
}